import { Switch } from '@/ui/Switch';

import { Wrapper } from '../shared';

const Widget = ({
	disabled,
	formContext,
	id,
	onChange,
	readonly,
	value,
}) => {
	const { readonlyAsDisabled = true } = formContext;

	const handleChange = (value) => {
		onChange(value);
	};

	return (
		<div className="flex items-center space-x-2">
			<Switch
				checked={value}
				disabled={disabled || (readonlyAsDisabled && readonly)}
				id={id}
				name={id}
				onCheckedChange={!readonly ? handleChange : undefined}
			/>
		</div>
	);
};


const SwitchWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { SwitchWidget };
